/** Chat models that can be chosen in project and flow settings. */
export const OPENAI_CHAT_MODELS = [
  { value: 'gpt-6-astra', label: 'GPT-6 Astra' },
  { value: 'gpt-6.1-sol', label: 'GPT-6.1 Sol' },
  { value: 'gpt-6-luna', label: 'GPT-6 Luna' },
  { value: 'gpt-5.6-sol', label: 'GPT-5.6 Sol' },
  { value: 'gpt-5.6-terra', label: 'GPT-5.6 Terra' },
  { value: 'gpt-5.6-luna', label: 'GPT-5.6 Luna' },
  { value: 'gpt-4.1', label: 'GPT-4.1' },
  { value: 'gpt-4.1-mini', label: 'GPT-4.1 Mini' },
  { value: 'gpt-4o', label: 'GPT-4o' },
  { value: 'gpt-4o-mini', label: 'GPT-4o Mini' }
];

/**
 * Models OpenAI shuts down on October 23, 2026, mapped to the replacement
 * the chatbot already sends. Includes official aliases of those snapshots.
 */
export const DEPRECATED_OPENAI_MODELS = {
  'gpt-3.5-turbo-0125': 'gpt-5.6-terra',
  'gpt-3.5-turbo': 'gpt-5.6-terra',
  'gpt-3.5-turbo-completions': 'gpt-5.6-terra',
  'gpt-4-0613': 'gpt-5.6-sol',
  'gpt-4': 'gpt-5.6-sol',
  'gpt-4-0613-completions': 'gpt-5.6-sol',
  'gpt-4-completions': 'gpt-5.6-sol',
  'gpt-4-1106-preview': 'gpt-5.6-sol',
  'gpt-4-turbo': 'gpt-5.6-sol',
  'gpt-4-turbo-2024-04-09': 'gpt-5.6-sol',
  'gpt-4-turbo-completions': 'gpt-5.6-sol',
  'gpt-4.1-nano': 'gpt-5.6-luna',
  'gpt-4.1-nano-2025-04-14': 'gpt-5.6-luna',
  'gpt-4o-2024-05-13': 'gpt-5.6-sol',
  'gpt-image-1': 'gpt-5.6-sol',
  'o1-2024-12-17': 'gpt-5.6-sol',
  'o1': 'gpt-5.6-sol',
  'o1-pro-2025-03-19': 'gpt-5.6-sol',
  'o1-pro': 'gpt-5.6-sol',
  'o3-mini-2025-01-31': 'gpt-5.6-sol',
  'o3-mini': 'gpt-5.6-sol',
  'o4-mini-2025-04-16': 'gpt-5.6-terra',
  'o4-mini': 'gpt-5.6-terra',
  'ft-o4-mini-2025-04-16': 'gpt-5.6-terra'
};

/**
 * Still stored on existing projects and flows. The API substitutes the
 * replacement before the request is sent.
 */
export const LEGACY_OPENAI_CHAT_MODELS = [
  { value: 'gpt-4.1-nano', label: 'GPT-4.1 Nano (deprecated — uses GPT-5.6 Luna)' }
];

const MODEL_SETTING_KEYS = new Set(['model', 'extractionModel', 'arraySelectionModel']);

/**
 * Find AI model settings on a flow step that point at a deprecated model.
 * Walks generate-message, extraction, and array-selection settings.
 */
export function findDeprecatedModelSettings(value, found = [], seen = new Set()) {
  if (!value || typeof value !== 'object') {
    return found;
  }
  if (seen.has(value)) {
    return found;
  }
  seen.add(value);

  if (Array.isArray(value)) {
    value.forEach((item) => findDeprecatedModelSettings(item, found, seen));
    return found;
  }

  Object.entries(value).forEach(([key, child]) => {
    if (MODEL_SETTING_KEYS.has(key) && typeof child === 'string' && DEPRECATED_OPENAI_MODELS[child]) {
      found.push({
        field: key,
        model: child,
        replacement: DEPRECATED_OPENAI_MODELS[child]
      });
      return;
    }
    if (child && typeof child === 'object') {
      findDeprecatedModelSettings(child, found, seen);
    }
  });

  return found;
}

export const OPENAI_CHAT_MODEL_OPTIONS = [
  ...OPENAI_CHAT_MODELS,
  ...LEGACY_OPENAI_CHAT_MODELS
];
